import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ReportGlyph = /*#__PURE__*/createElement("g", {
  id: "report",
  transform: "scale(3.5)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M10.5 23.5H1.5C0.9 23.5 0.5 23.1 0.5 22.5V1.5C0.5 0.9 0.9 0.5 1.5 0.5H14.8C15.1 0.5 15.3 0.6 15.5 0.8L19.2 4.5C19.4 4.7 19.5 4.9 19.5 5.2V8.5M4.5 13.9L7.5 10.9C7.8 10.6 8.2 10.6 8.6 10.8L10 11.7C10.4 11.9 10.8 11.9 11.1 11.6L13.8 8.7M4.5 6.5V16.5H8.5M17.5 14.5V20.5M17.5 20.5L15.3 18.3M17.5 20.5L19.7 18.3M17.5 23.5C20.8 23.5 23.5 20.8 23.5 17.5C23.5 14.2 20.8 11.5 17.5 11.5C14.2 11.5 11.5 14.2 11.5 17.5C11.5 20.8 14.2 23.5 17.5 23.5Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const Report = createSvg({
  name: 'report',
  path: ReportGlyph
});

export default Report;
export { ReportGlyph };
